(function (global, factory) {
  "use strict";

  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (global) global.BBSupplierProductionFiles = api;
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  "use strict";

  function displayFiles(files) {
    var available = Array.isArray(files) ? files.slice() : [];
    var packages = available.filter(function (file) {
      return Boolean(file && file.is_zip);
    });
    return packages.length ? packages : available;
  }

  return {displayFiles: displayFiles};
});
